import React from "react";

import ContactsPermissions from "./Permissions/ContactsPermissions";
import UsersPermissions from "./Permissions/UsersPermissions";
import EntitiesPermissions from "./Permissions/EntitiesPermissions";
import ListingPermissions from "./Permissions/ListingPermissions";
import NotesPermissions from "./Permissions/NotesPermissions";
import ReportsPermissions from "./Permissions/ReportsPermissions";
import { H3 } from "../../../AbstractElements";

export default function RoleFormPermissions({ register, setValue }) {
  const handleAll = (e) => {
    const id = e.target.id;
    const checked = e.target.checked;

    setValue(`permissions.[list_${id}]`, checked, { shouldDirty: true });
    setValue(`permissions.[create_${id}]`, checked, { shouldDirty: true });
    setValue(`permissions.[edit_${id}]`, checked, { shouldDirty: true });
    setValue(`permissions.[delete_${id}]`, checked, { shouldDirty: true });
    if (id == "contact") {
      setValue(`permissions.[export_${id}]`, checked, { shouldDirty: true });
    }
  };
  return (
    <>
      <H3 attrH3={{ className: "mb-3" }}>Permisos</H3>

      <ContactsPermissions
        register={register}
        handleAll={handleAll}
      ></ContactsPermissions>

      <UsersPermissions
        register={register}
        handleAll={handleAll}
      ></UsersPermissions>
      <EntitiesPermissions
        register={register}
        handleAll={handleAll}
      ></EntitiesPermissions>

      <ListingPermissions
        register={register}
        handleAll={handleAll}
      ></ListingPermissions>

      <NotesPermissions
        register={register}
        handleAll={handleAll}
      ></NotesPermissions>

      <ReportsPermissions
        register={register}
        handleAll={handleAll}
      ></ReportsPermissions>
    </>
  );
}
